import { SVGAttributes } from 'react';

export const SuccessIcon = ({ className, ...rootProps }: SVGAttributes<SVGSVGElement>) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rootProps}
        className={className}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.66797 9.99984C1.66797 5.39984 5.4013 1.6665 10.0013 1.6665C14.6013 1.6665 18.3346 5.39984 18.3346 9.99984C18.3346 14.5998 14.6013 18.3332 10.0013 18.3332C5.4013 18.3332 1.66797 14.5998 1.66797 9.99984ZM3.33464 9.99984C3.33464 13.6748 6.3263 16.6665 10.0013 16.6665C13.6763 16.6665 16.668 13.6748 16.668 9.99984C16.668 6.32484 13.6763 3.33317 10.0013 3.33317C6.3263 3.33317 3.33464 6.32484 3.33464 9.99984ZM13.947 8.06508C14.2591 7.72689 14.2381 7.19968 13.8999 6.88751C13.5617 6.57534 13.0345 6.59642 12.7223 6.93461L8.3106 11.714L6.84056 10.2439C6.51512 9.91848 5.98748 9.91848 5.66205 10.2439C5.33661 10.5694 5.33661 11.097 5.66205 11.4224L7.74538 13.5058C7.90575 13.6661 8.12455 13.7542 8.35129 13.7497C8.57804 13.7451 8.79314 13.6484 8.94697 13.4817L13.947 8.06508Z"
            fill="currentColor"
        />
    </svg>
);

SuccessIcon.displayName = 'SuccessIcon';
